import { all, call, put, select } from 'redux-saga/effects';
import { apiRequest } from '../../api/api.saga-services';
import { fetchWrikeFolderMeetingsApi } from '../../api/request-config/wrike.api';
import { storeWrikeFolderMeeting } from './wrike-folder-meeting.actions';
import * as wrikeFolderMeetingTypes from './wrike-folder-meeting.types';
import { wrikeFolderMeetingSelectors } from './wrike-folder-meeting.selectors';
import * as actions from './wrike-folder-meeting.actions';

export function* fetchWrikeFolderMeetings() {
  const folderMeetings: wrikeFolderMeetingTypes.IWrikeFolderMeeting[] = yield call(
    apiRequest,
    fetchWrikeFolderMeetingsApi(),
  );

  if (Array.isArray(folderMeetings) && folderMeetings.length > 0) {
    yield all(folderMeetings.map((meeting) => put(storeWrikeFolderMeeting(meeting))));
  }
  return folderMeetings;
}

export function* clearAllWrikeFolderMeetings() {
  const wrikeFolderMeetingIds: wrikeFolderMeetingTypes.IWrikeFolderMeeting['id'][] = yield select(
    wrikeFolderMeetingSelectors.selectResourceIds,
  );
  yield put(actions.clearWrikeFolderMeeting(wrikeFolderMeetingIds));
}
